export interface ILineItemTargetingCriterionValueAPI {
  lineitemtargetingcriterionvalue_id?: number;
  lineitemtargetingcriterion_id?: number;
  code: string;
  value: string;
}

export interface ILineItemTargetingCriterionAPI {
  lineitem_id: number;
  lineitemtargetingcriterion_id: number;
  lineitemtargetingcriterion_values: ILineItemTargetingCriterionValueAPI[];
  targetingcriterion_id: number;
}

export default class LineItemTargetingCriterion {
  lineItemID: number;
  targetingCriterionID: number;
  values: ILineItemTargetingCriterionValueAPI[];
  id: number;

  constructor(
    id: number = -1,
    lineItemID: number,
    targetingCriterionID: number,
    values: ILineItemTargetingCriterionValueAPI[] = [],
  ) {
    this.id = id;
    this.lineItemID = lineItemID;
    this.targetingCriterionID = targetingCriterionID;
    this.values = values;
  }

  static fromApi(apiObject: ILineItemTargetingCriterionAPI): LineItemTargetingCriterion {
    return new LineItemTargetingCriterion(
      apiObject.lineitemtargetingcriterion_id,
      apiObject.lineitem_id,
      apiObject.targetingcriterion_id,
      apiObject.lineitemtargetingcriterion_values,
    );
  }

  toApi(): ILineItemTargetingCriterionAPI {
    return {
      lineitem_id: this.lineItemID,
      targetingcriterion_id: this.targetingCriterionID,
      lineitemtargetingcriterion_values: this.values,
      lineitemtargetingcriterion_id: this.id,
    };
  }

  toString() {
    return this.values.map((value) => value.value).join(', ');
  }
}
